import React, { Fragment, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { isEmpty, keys } from 'lodash-es';

import TopAppsTable from '../components/TopAppsTable';
import Header from '../../shared/components/Header';
import RelatedAppStoreAnalitics from '../../shared/components/RelatedAppStoreAnalitics';
import TopChartsFilters from '../../shared/components/TopChartsFilters';
import LoadingOverlay from '../../../../../components/LoadingOverlay';
import QuickViewProvider from '../../../../../components/QuickView/index';
import { initParams, parseUrlForFilters } from '../configs';
import helpers from '../../../../../utils/helpers';

// Static configs
const {
  defaultOsName, data, report, shareOptions, defaultStoreName, availableCategories,
} = initParams();
const enableTopFilters = ['store', 'categories', 'countries', 'single_date_picker'];

const PageContainer = () => {
  useEffect(() => {
    const onPopstate = () => window.location.reload();
    window.addEventListener('popstate', onPopstate);
    return () => window.removeEventListener('popstate', onPopstate);
  }, []);

  const p = parseUrlForFilters();

  const baseUrl = ({ store, category, country }) => `${window.location.origin}/store-insights/top-charts/${store}/${category}/${country}`;

  const handleFilterChange = useCallback((filter) => {
    const defaultParsedURL = !filter.store && (keys(p).length === 1 && p.store === undefined);
    const defaultStore =
      (filter.store && (
        filter.store === 'itunes-connect'
        || filter.store === 'itunes_connect'))
      || defaultParsedURL
      || (!filter.store && p.store === 'itunes-connect');
    const defaultFilters = {
      category: defaultStore ? 'top-overall' : 'overall',
      country: 'united-states',
      store: defaultStore ? 'itunes-connect' : 'google-play',
    };
    const countrySlug = filter.country &&
      helpers.convertToSlug(COUNTRIES_ARRAY[filter.country]);
    const parsedDate = filter.date || p.date;
    const categorySlug = availableCategories[filter.category];
    const allFilters = {
      store: (filter.store || defaultParsedURL) ? defaultFilters.store : p.store,
      category: categorySlug || (filter.store && defaultFilters.category) || p.category || defaultFilters.category,
      country: countrySlug || p.country || defaultFilters.country,
    };
    window.location.assign(`${baseUrl(allFilters)}${parsedDate ? `?date=${parsedDate}` : ''}`);
  }, []);

  const handleShowMore = useCallback(() => {
    document.getElementById('schedule-a-demo-modal').classList.add('in');
  }, []);
  const childComponent = (
    <RelatedAppStoreAnalitics
      store={report.store}
      type="Apps"
    />
  );
  const renderPortal = () => ReactDOM.createPortal(childComponent, document.getElementById('related-apps-store-analytics'));

  const headline = <span>Top <span className="text-blue">{defaultOsName}</span> Apps</span>;

  const subheadline = `Free app store rank data for ${defaultStoreName}`;

  return (
    <Fragment>
      <LoadingOverlay loading={isEmpty(data)} />
      <Fragment>
        <Header
          headline={headline}
          subheadline={subheadline}
        />
        <section className="container">
          <TopChartsFilters
            filters={report}
            enableTopFilters={enableTopFilters}
            shareOptions={shareOptions}
            onFilterChange={handleFilterChange}
          />
          <QuickViewProvider>
            <TopAppsTable
              tableData={data}
              report={report}
              onShowMore={handleShowMore}
            />
          </QuickViewProvider>
        </section>
      </Fragment>
      {renderPortal()}
    </Fragment>
  );
};

export default PageContainer;
